<template>
    <div class="container">
        <div v-for="(dependant, index) in dependants" class="dependant">
            <dependant :index="index" :stepValid="isValid()"></dependant>
        </div>
        <div class="flex-grid__g-8">
            <button class="a-button u-margin-top-0 u-margin-bottom-0" @click="add">Add Dependant</button>
        </div>
        <step-button :next-valid="isValid()"></step-button>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapState, mapGetters, mapActions} from 'vuex';
    import Dependant from 'pages/fatal-accident-claims/dependency/steps/dependants/Dependant.vue';
    import StepButton from 'components/StepButton.vue'
    import FormValidator from 'components/form/validator/mixin';
    import { isStepValid, setStepValid }  from 'services/routingMethods';

    export default {
        mixins: [
            FormValidator
        ],
        components: {
            Dependant,
            StepButton
        },
        computed: {
            ...mapGetters('fatal/dependency/dependants', {
                dependants: 'dependants',
                valid: 'allDependantsValid',
            }),
        },
        watch: {
            '$form.$valid'(){
                this.updateValid();
            },
            'valid'(){
                this.updateValid();
            }
        },
        created() {
            if (!this.dependants.length) {
                this.addDependant();
            }
        },
        methods: {
            ...mapActions('fatal/dependency/dependants', ['addDependant']),
            add() {
                this.addDependant().then(() => {
                    this.$nextTick(() => {
                        this.updateValid()
                    })
                });
            },
            updateValid(){
                return setStepValid(this.valid && this.$valid());
            },
            isValid() {
                return this.$valid() && isStepValid(3);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// TheDependants.vue?3847abe9